export default __webpack_public_path__ + "static/media/Chargeback.b65a0d2a.xlsx";